import styled, { css, keyframes } from "styled-components";

const ONBOARDING_ANIMATION_WITH_BOUNCE = keyframes`
    0% {
        transform: translateY(0px);
    }
    40% {
        transform: translateY(-70px);    
    }
    80% {
        transform: translateY(20px);    
    }
    90% {
        transform: translateY(-10px); 
    }
    100% {
        transform: translateY(0px); 
    }
`;

export const VideoSlideLayoutBox = styled.div<{
  onboardingMovement: boolean;
  individualAnimationDuration: number;
  animationAppearances: number;
}>`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  ${props =>
    props.onboardingMovement
      ? css`
          animation: ${ONBOARDING_ANIMATION_WITH_BOUNCE}
            ${props.individualAnimationDuration}s ease-out
            ${props.animationAppearances} alternate;
        `
      : null}
`;
